/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products */
  static #STORAGE_KEY = 'viewedProducts';

  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 8;

  /**
   * Adds a product to the recently viewed products list.
   *
   * @param {string | number} productId
   */
  static addProduct(productId) {
    const normalizedProductId = String(productId);
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter(
      (id) => id !== normalizedProductId
    );

    viewedProducts.unshift(normalizedProductId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(
      this.#STORAGE_KEY,
      JSON.stringify(viewedProducts)
    );
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products.
   *
   * @returns {string[]}
   */
  static getProducts() {
    try {
      const storedProducts = JSON.parse(
        localStorage.getItem(this.#STORAGE_KEY) || '[]'
      );

      if (!Array.isArray(storedProducts)) {
        return [];
      }

      return storedProducts.map(String);
    } catch (error) {
      console.error(
        'Recently viewed products could not be read:',
        error
      );

      return [];
    }
  }
}